import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="tab-unique-id"
export default class extends Controller {
  static values = {
    tabUniqueId: String
  }

  initialize() {
    let tabId = sessionStorage.getItem('tabUniqueId')
    if (!tabId) {
      tabId = crypto.randomUUID()
      sessionStorage.setItem('tabUniqueId', tabId)
    }
    this.tabUniqueIdValue = tabId
  }
}
